export const stulya = {
    stul__sta_1: {
        name: "Стул «СТА-1 ESD»",
        title: "Стул «СТА-1 ESD»",
        price: 0,
        active: false,
        type: null,
        width: null,
        depth: null,
        piece: 0,
        price_esd: 0,
        position: "table",
    },
    stul__sta_2: {
        name: "Стул «СТА-2 ESD»",
        title: "Стул «СТА-2 ESD»",
        price: 0,
        active: false,
        type: null,
        width: null,
        depth: null,
        piece: 0,
        price_esd: 0,
        position: "table",
    },
};
export const gazlift = {
    gazlift: {
        name: "Газлифт 260 мм, шт",
        price: 0,
        active: false,
        type: "1",
        piece: 0,
        price_esd: 0,
        position: "down",
    },
};
export const koltso_opornoe = {
    koltso_opornoe: {
        name: "Кольцо опорное, шт",
        price: 0,
        active: false,
        type: "1",
        piece: 0,
        price_esd: 0,
        position: "down",
    },
};
export const podlokotniki__esd = {
    podlokotniki__esd: {
        name: "Подлокотники антистатические",
        price: 0,
        active: false,
        type: "Регулируемые",
        piece: 0,
        price_esd: 0,
        position: "down",
    },
};
export const glaydery__esd = {
    glaydery__esd: {
        name: "Глайдеры",
        price: 0,
        active: false,
        type: "—",
        piece: 0,
        price_esd: 0,
        position: "down",
    },
};
